import { $generateHtmlFromNodes } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { CLEAR_EDITOR_COMMAND } from 'lexical';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import { sendEvent } from 'lib/gtag';

import { useUser } from 'providers/UserProvider';

const sanitize = (html) => html.replaceAll(' style=""', '');

const SendButton = ({
  className,
  disabled = false,
  gaEventCategory,
  onClick,
}) => {
  const { isLoggedIn } = useUser();

  const [editor] = useLexicalComposerContext();

  const cleanupEditor = useCallback(
    () => editor.dispatchCommand(CLEAR_EDITOR_COMMAND),
    [editor]
  );

  const onClickHandler = useCallback(() => {
    editor.getEditorState().read(() => {
      const html = $generateHtmlFromNodes(editor);

      if (html.length === 0) {
        return;
      }
      sendEvent({
        category: gaEventCategory,
        action: isLoggedIn ? 'send_comment' : 'send_comment_unlogged',
      });

      onClick(sanitize(html));
      cleanupEditor();
    });
  }, [editor, onClick]);

  return (
    <Button
      aria-label={
        disabled
          ? 'Primeiro você deve escrever um texto para poder enviar'
          : 'Enviar'
      }
      className={className}
      disabled={disabled}
      icon={<Icon name="send" />}
      size="size4"
      type="primary"
      onClick={onClickHandler}
    />
  );
};

SendButton.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  gaEventCategory: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SendButton;
